import { render, staticRenderFns } from "./FailedAuthorization.vue?vue&type=template&id=1d2a11be&"
import script from "./FailedAuthorization.vue?vue&type=script&lang=js&"
export * from "./FailedAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports